module.exports = __webpack_public_path__ + "assets/flag-ac53b9ea0e385984719b87f68488f072.png";